var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5023_62566)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(0 0.5)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5023_62566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.85899 1.86954C7.77237 1.71865 7.64748 1.5933 7.49692 1.50612C7.34636 1.41895 7.17546 1.37305 7.00149 1.37305C6.82751 1.37305 6.65662 1.41895 6.50606 1.50612C6.3555 1.5933 6.2306 1.71865 6.14399 1.86954L0.144114 12.0782C-0.255761 12.7589 0.223739 13.6243 1.00161 13.6243H13.0005C13.7784 13.6243 14.2587 12.758 13.858 12.0782L7.85899 1.86954ZM6.99974 4.87429C7.46786 4.87429 7.83449 5.27854 7.78724 5.74491L7.48099 8.81354C7.4707 8.93409 7.41554 9.04638 7.32642 9.12822C7.23731 9.21005 7.12073 9.25546 6.99974 9.25546C6.87875 9.25546 6.76217 9.21005 6.67305 9.12822C6.58394 9.04638 6.52878 8.93409 6.51849 8.81354L6.21224 5.74491C6.20124 5.63487 6.21341 5.52374 6.24798 5.41868C6.28254 5.31363 6.33873 5.21698 6.41291 5.13496C6.4871 5.05294 6.57765 4.98737 6.67872 4.94247C6.77979 4.89758 6.88914 4.87435 6.99974 4.87429ZM7.00149 10.1243C7.23355 10.1243 7.45611 10.2165 7.62021 10.3806C7.7843 10.5447 7.87649 10.7672 7.87649 10.9993C7.87649 11.2314 7.7843 11.4539 7.62021 11.618C7.45611 11.7821 7.23355 11.8743 7.00149 11.8743C6.76942 11.8743 6.54686 11.7821 6.38277 11.618C6.21868 11.4539 6.12649 11.2314 6.12649 10.9993C6.12649 10.7672 6.21868 10.5447 6.38277 10.3806C6.54686 10.2165 6.76942 10.1243 7.00149 10.1243Z",
    fill: "#DC3545"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5023_62566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5023_62566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDanger);
export default __webpack_public_path__ + "static/media/ic-danger.ff8531894587241df28c717c9f55b44f.svg";
export { ForwardRef as ReactComponent };